<div class="grid grid-cols-4 items-center justify-start col-span-6 gap-4">
  <app-checkbox
    [label]="'Configuration.EWG.Options.Roof' | translate"
    *ngIf="roofProduct$ | async as roofProduct"
    [(checked)]="selectedRoof"
    (checkedChange)="toggleRoof(roofProduct.id)"
    [isReadonly]="order.status == OrderStatusEnum.Ordered || !isRoofValid"
    class="col-span-4 md:col-span-2 xl:col-span-1"
  ></app-checkbox>
